import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';
import { Row, Col, OverlayTrigger, Tooltip, Spinner, Popover, Button } from 'react-bootstrap';
import printJS from 'print-js';
import toast, { Toaster } from 'react-hot-toast';

import { useGetDta } from '../../../hooks/useGetDta';
import LoadinSpin from '../../ui/LoadinSpin';
import { TblmyPays, headTbl } from '../../../data/tables';
import { useShowColums, useShowColumsHook } from '../../../hooks/useShowColums';
import DropDownsCol from '../../ui/DropDownsCol';
import Table from '../../Table';
import { fetchConToken } from '../../../api/fetch';
import ChangeConfirmation from '../../ui/ChangeConfirmation';
import BtnsPago from './BtnsPago';
import { checkAccess } from '../../../helpers/details';
import { AuthContext } from '../../../auth/AuthContext';
import { getInitialColumns } from '../../../data/cards';

const PagosUs = ({ activo, activeTab }) => {
    const { id } = useParams();
    const { auth } = useContext(AuthContext);

    const permisos = checkAccess('Facturación', auth.accesos);
    const {
        fact_generar_pago,
         } = permisos.functions
    let idR = atob(id);

    const initialColums = getInitialColumns('my/', TblmyPays);
    const { toggleCheck, columnasVisibles } = useShowColumsHook(initialColums, 'my/');




    const toastId = useRef(null);
    const [show, setShow] = useState(false);
    const [dt, setDt] = useState({
        head: `Id pago `,
        body: `Se creara la fatura electrónnica correspondiente al pago `,
        endpoint: `usertools/facbypay`,
        data: {},
    });

    const { loading, data, getInfo } = useGetDta(`factura/my/${idR}`);
    const { bills = [], count = 0 } = data;
    useEffect(() => {
        if (activo === 'facturacion' || activeTab === 'pagos') getInfo(`factura/my/${idR}`);
    }, [activo, activeTab, idR]);
    const getFile = async (item) => {
        toastId.current = toast('Generando PDF...', {
            position: 'top-right',
            icon: <Spinner aria-label="Default status example" />,
        });
        const re = await fetchConToken(`factura/print`, item, 'PUT');

        toast.dismiss(toastId.current);
        printJS({ printable: re.data, showModal: true, type: 'pdf', base64: true });
    };
    const chekfactura = async (factura) => {
        setDt({
            head: `Id pago ${factura?.id}`,
            body: `Se creara la fatura electrónica correspondiente al pago `,
            endpoint: `usertools/facbypay`,
            data: { ...factura },
        });
        setShow(true);
    };
    const StatusColumn = ({ row }) => {
        return <span className={classNames('badge bg-primary')}>{row.original?.estado}</span>;
    };
    const PColumn = ({ row }) => {
        return <span className="text-center">${row.original.pagado}</span>;
    };
    const TColumn = ({ row }) => {
        return <span className="text-center">${row.original.total}</span>;
    };
    const CColumn = ({ row }) => {
        return <span className="text-center">${row.original.comision}</span>;
    };
    const FechaColumn = ({ row }) => {
        return <div style={{ whiteSpace: 'pre-line' }}>{row.original.fecha_pago}</div>;
    };
    const ActionColumn = ({ row }) => {
        return (
            <>
                <>
                    <OverlayTrigger
                        trigger="focus"
                        placement="left"
                        overlay={
                            <Popover>
                                <Popover.Header as="h3" className="text-center">
                                    Imprimir
                                </Popover.Header>

                                <Popover.Body>
                                    <div className="row row-cols-3">
                                        <Button onClick={() => getFile({ type: 'recibo', id: row.original.id })}>
                                            <i className="mdi mdi-printer mdi-18px " />
                                            Recibo
                                        </Button>
                                        <Button onClick={() => getFile({ type: 'factura', id: row.original.id })}>
                                            <i className="mdi mdi-printer mdi-18px " />
                                            Factura
                                        </Button>
                                        <Button onClick={() => getFile({ type: 'pos', id: row.original.id })}>
                                            <i className="mdi mdi-printer mdi-18px " />
                                            Recibo POS
                                        </Button>
                                    </div>
                                </Popover.Body>
                            </Popover>
                        }
                        rootClose={false}>
                        <Button size="sm">
                            {' '}
                            <i className="mdi mdi-printer mdi-18px "></i>
                        </Button>
                    </OverlayTrigger>

                    {!row.original.sat && fact_generar_pago && (
                        <OverlayTrigger
                            className="action-icon "
                            placement="left"
                            overlay={<Tooltip id="overlay-example">Generar factura SAT</Tooltip>}>
                            <Button
                                size="sm"
                                variant="info"
                                onClick={() => chekfactura({ id: row.original.id, id_user: row.original.id_user })}>
                                {' '}
                                <i className="mdi mdi-cloud-print-outline mdi-18px "></i>
                            </Button>
                        </OverlayTrigger>
                    )}
                </>
            </>
        );
    };
    const columns = [
        {
            Header: 'Nº pago',
            accessor: 'id',
            sort: true,
        },
        {
            Header: 'Estado',
            accessor: 'estado',
            sort: true,
            Cell: StatusColumn,
        },
        {
            Header: 'Tipo',
            accessor: 'type',
            sort: true,
        },

        {
            Header: 'Corte',
            accessor: 'fecha_corte',
            sort: true,
        },
        {
            Header: 'Prox. Corte',
            accessor: 'fecha_prox',
            sort: true,
        },
        {
            Header: 'Total ',
            accessor: 'total',
            sort: true,
            Cell: TColumn,
        },
        {
            Header: 'Pagado',
            accessor: 'pagado',
            sort: true,
            Cell: PColumn,
        },
        {
            Header: 'Comisión',
            accessor: 'comision',
            sort: true,
            Cell: CColumn,
        },
        {
            Header: 'Fecha pago',
            accessor: 'fecha_pago',
            sort: true,
            Cell:FechaColumn
        },
        {
            Header: 'Forma Pago',
            accessor: 'forma_pago',
            sort: true,
        },

        {
            Header: 'Folio',
            accessor: 'folio',
            sort: true,
        },

        {
            Header: 'Agente',
            accessor: 'agente',
            sort: true,
        },
        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(bills.length);
    if (loading) return <LoadinSpin />;
    return (
        <div className="mt-3">
            {' '}
            <Row className="mb-2 ">
                <Col xl="auto">
                    <DropDownsCol
                        cols={columnasVisibles} // Pasar el estado desde TblZonas
                        toggleCheck={toggleCheck} // Pasar la función de toggleCheck desde TblZonas
                    />
                </Col>

                <BtnsPago pgs={bills.length} size={count} activeTab={activeTab} activo={activo} callBk={getInfo} />
            </Row>
            <Table
                columns={columns}
                data={bills}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                columnasVisibles={columnasVisibles}
                isSearchable={true}
                searchBoxClass="mb-2"
            />{' '}
            <ChangeConfirmation show={show} onClose={() => setShow(false)} info={dt} callBk={getInfo} method="PUT" />
            <Toaster position="top-right" />
        </div>
    );
};

export default PagosUs;
